import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import type { Dispatch, ReactElement } from 'react';

import { randomUUID } from '@core/utils/uuid';

type YearSelectorProps = {
  selectedYear: number;
  setSelectedYear: Dispatch<number>;
  yearOpts: {
    year: number;
    hasValues: boolean;
  }[];
  /** @default '15rem' */
  selectWidth?: string;
  disabled?: boolean;
};

export const YearSelector = ({
  selectedYear,
  setSelectedYear,
  yearOpts,
  selectWidth = '15rem',
  disabled,
}: YearSelectorProps): ReactElement => (
  <FormControl
    fullWidth={selectWidth === 'fullWidth'}
    sx={selectWidth === 'fullWidth' ? {} : { width: selectWidth }}
    disabled={disabled}
  >
    <InputLabel>Select year</InputLabel>
    <Select
      value={selectedYear}
      onChange={(e): void => {
        setSelectedYear(Number(e.target.value));
      }}
      label='Select year'
      fullWidth={selectWidth === 'fullWidth'}
    >
      {yearOpts.map((yr) => (
        <MenuItem key={randomUUID()} value={yr.year}>
          <Box>
            <Typography variant='body2'>
              {yr.year}
              {yr.hasValues && (
                <Typography className='sublabel' variant='body3'>
                  {' '}
                  - has forecast data
                </Typography>
              )}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
